<template>
  <div>
    <router-link :to="{ name: 'moderator.categories.create' }" class="btn btn-primary float-right px-2 py-2">Add New</router-link>
    <h2>Categories</h2>
    <div class="card">
      <div class="card-body">
        <table class="table table-responsive table-borderless">
          <tbody>
            <tr v-for="(category, i) in categories" :key="`category-${i}`">
              <td width="20px">{{ i+1 }}</td>
              <td>
                <p :class="loading ? 'skeleton skeleton-text' : ''"><router-link :to="{ name: 'moderator.categories.show', params: { id: category.id }}">{{ category.name }}</router-link></p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.fetch()
  },

  data() {
    return {
      categories: [{}, {}, {}, {}, {}],
      loading: true
    }
  },

  methods: {
    fetch() {
      this.$axios.get('/api/v1/moderator/categories').then(response => {
        this.categories = response.data.categories
        this.loading = false
      })
    }
  }
}
</script>